// src/utils/s3UrlParser.js

/**
 * Parses the season number from a given URL.
 * @param {string} url - The URL to parse.
 * @returns {number|null} - The season number, or null if not found.
 */
export const parseSeasonFromUrl = (url) => {
    const seasonMatch = url.match(/\/S(\d+)\//i);
    if (seasonMatch) {
      return parseInt(seasonMatch[1], 10);
    }
    return null;
  };
  